// extracted by mini-css-extract-plugin
export default {"Tooltip":"Tooltip_Tooltip__NRBg-","Light":"Tooltip_Light__iPFWs","Dark":"Tooltip_Dark__2s68M"};